import { object, string } from 'yup';

import { TEMPLATE_TYPES } from 'common/constants';
import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();
    return object().shape({
        language: string().required(REQUIRED_TEXT).nullable(),
        title: string().required(REQUIRED_TEXT).nullable(),
        system: string().when('type', (value, schema) => {
            if (
                [TEMPLATE_TYPES.BOM_TYPE, TEMPLATE_TYPES.SYSTEM_TYPE].includes(
                    value,
                )
            ) {
                return schema.required(REQUIRED_TEXT).nullable();
            }
            return schema.nullable();
        }),
    });
};
